import {
    DEVICES_BULK_UNPAIRING_OPEN_MODAL,
    DEVICES_BULK_UNPAIRING_CLOSE_MODAL,
    DEVICES_BULK_UNPAIRING_REQUEST,
    DEVICES_BULK_UNPAIRING_RESULT,
    DEVICES_BULK_UNPAIRING_SET_DEVICE,
    DEVICES_BULK_SEARCH_DEVICE_REQUEST,
    DEVICES_BULK_SEARCH_DEVICE_RESULT,
    CLEAR_REDUX,
} from "Redux/actionTypes";

const INIT_STATE = {
    loading: false,
    openModal: false,
    result: null,
    error: null,
    devices: [],
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {
        case DEVICES_BULK_UNPAIRING_OPEN_MODAL:
            return { ...state, openModal: true, devices: action.payload };

        case DEVICES_BULK_UNPAIRING_CLOSE_MODAL:
            return { ...state, openModal: false };

        case DEVICES_BULK_UNPAIRING_REQUEST:
            return { ...state, loading: true };

        case DEVICES_BULK_UNPAIRING_RESULT:
            return { ...state, loading: false, result: action.payload };

        case DEVICES_BULK_UNPAIRING_SET_DEVICE:
            return { ...state, devices: action.payload, loading: false }

        case DEVICES_BULK_SEARCH_DEVICE_REQUEST:
            return { ...state, loading: true }
        case DEVICES_BULK_SEARCH_DEVICE_RESULT:
            return { ...state, loading: false }

        case CLEAR_REDUX:
            return ["", "DEVICES_BULK_UNPAIRING"].includes(action.payload.option)
                ? action.payload.parameters ? { ...state, ...action.payload.parameters } : { ...INIT_STATE }
                : { ...state }
        default:
            return state;
    }
};